module.exports = __webpack_public_path__ + "img/img-e61f27.png";